import NodeHandler from "../node_handler";

class Toggler extends NodeHandler{
    __init_dom_schema(){
        return {
            button: {
                selector: '.js-toggler__button',
                actions: {
                    'click': this.onButtonClick.bind(this)
                }
            }
        }
    }
    __init() {
        this.id = this.node.getAttribute('data-id')
        this.registerEvents('toggled')
    }
    onButtonClick(event){
        this.node.classList.toggle('is--active')
        this.dispatchEvent('toggled', {
            is_active: this.node.classList.contains('is--active')
        })
    }
}

export default Toggler